<template>
  <div>
    <el-tabs v-model="activeItemsTab" @tab-click="handleClick">
        <el-tab-pane name="service" label="Service">
            <itemService ref="service" />
        </el-tab-pane>
        <el-tab-pane name="nonInventory" label="Non Inventory">
            <itemNonInventory ref="nonInventory" />
        </el-tab-pane>
        <el-tab-pane name="inventory" label="Inventory">
            <itemInventory ref="inventory" />
        </el-tab-pane>
        <el-tab-pane name="inventoryAssembly" label="Inventory Assembly">
            <itemInventoryAssembly ref="inventoryAssembly" />
        </el-tab-pane>
        <el-tab-pane name="groupedItem" label="Grouped Item">
            <itemGroupedItem ref="groupedItem" />
        </el-tab-pane>
        <el-tab-pane name="digital" label="Digital">
            <itemDigital ref="digital" />
        </el-tab-pane>
        <el-tab-pane name="fixedAsset" label="Fixed Asset">
            <itemFixedAsset ref="fixedAsset" />
        </el-tab-pane>
        <el-tab-pane name="rentalAsset" label="Rental Asset">
          <itemRentalAsset ref="rentalAsset" />
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import settingTable from '@/components/settings/settingTable'
  import itemService from '@/components/settings/items/itemService.vue'
  import itemNonInventory from '@/components/settings/items/itemNonInventory.vue'
  import itemInventory from '@/components/settings/items/itemInventory.vue'
  import itemInventoryAssembly from '@/components/settings/items/itemInventoryAssembly.vue'
  import itemDigital from '@/components/settings/items/itemDigital.vue'
  import itemGroupedItem from '@/components/settings/items/itemGroupedItem.vue'
  import itemFixedAsset from '@/components/settings/items/itemFixedAsset.vue'
  import itemRentalAsset from '@/components/settings/items/itemRentalAsset.vue'
  let moment = require('moment')
  import axios from 'axios'
  export default {
    components: {
      settingTable,
      itemService,
      itemNonInventory,
      itemInventory,
      itemInventoryAssembly,
      itemGroupedItem,
      itemDigital,
      itemFixedAsset,
      itemRentalAsset,
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    data() {
      return {
        moment: moment,
        activeItemsTab: 'service',
      }
    },
    methods: {
      handleClick(tab, event) {
        if (tab.name === 'service') {
          this.$refs['service'].loadList(tab.name)
        } else if (tab.name === 'nonInventory') {
          this.$refs['nonInventory'].loadList(tab.name)
        } else if (tab.name === 'inventory') {
          this.$refs['inventory'].loadList(tab.name)
        } else if (tab.name === 'groupedItem') {
          this.$refs['groupedItem'].loadList(tab.name)
        } else if (tab.name === 'digital') {
          this.$refs['digital'].loadList(tab.name)
        }
      },
      loadFirstTab() {
        this.activeItemsTab = 'service'
        this.$refs['service'].loadList('service')
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>